import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { AuthProvider } from "./hooks/useAuth";
import { CountdownProvider } from "./hooks/useCountdown";

import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <CountdownProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </CountdownProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
